import { render, staticRenderFns } from "./TakeNumber.vue?vue&type=template&id=73eff130&scoped=true&"
import script from "./TakeNumber.vue?vue&type=script&lang=js&"
export * from "./TakeNumber.vue?vue&type=script&lang=js&"
import style0 from "./TakeNumber.vue?vue&type=style&index=0&id=73eff130&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73eff130",
  null
  
)

export default component.exports